import { GRD } from "@/constants/testIds";
import ReportSectionEditor from "@/components/report/ReportSectionEditor";

export default function ReportDesignCanvas({
  firstPageHeaderHtml,
  subsequentHeaderHtml,
  footerHtml,
  onChange,
  disabled,
}) {
  return (
    <div className="grd__canvas-wrap" data-testid={GRD.canvas}>
      <div className="grd-paper">
        <section className="grd-band">
          <div className="grd-band__bar">
            Custom First Page Header
            <span className="grd-band__hint">Shown on page 1 only</span>
          </div>
          <div className="grd-band__editor">
            <ReportSectionEditor
              value={firstPageHeaderHtml}
              onChange={(html) => onChange("firstPageHeaderHtml", html)}
              disabled={disabled}
              surfaceClassName="grd-editor__surface--first"
              testId={GRD.firstHeader}
              insertPlaceholderTestId={`${GRD.firstHeader}-insert-placeholder`}
              insertLogoTestId={`${GRD.firstHeader}-insert-logo`}
              placeholder="Design the first-page letterhead…"
            />
          </div>
        </section>

        <section className="grd-band">
          <div className="grd-band__bar">
            Custom Header — Subsequent Pages
            <span className="grd-band__hint">Compact header for page 2+</span>
          </div>
          <div className="grd-band__editor">
            <ReportSectionEditor
              value={subsequentHeaderHtml}
              onChange={(html) => onChange("subsequentHeaderHtml", html)}
              disabled={disabled}
              surfaceClassName="grd-editor__surface--subsequent"
              testId={GRD.subsequentHeader}
              insertPlaceholderTestId={`${GRD.subsequentHeader}-insert-placeholder`}
              insertLogoTestId={`${GRD.subsequentHeader}-insert-logo`}
              placeholder="Design the subsequent-page header…"
            />
          </div>
        </section>

        <section className="grd-band" data-testid={GRD.bodyBand}>
          <div className="grd-band__bar grd-band__bar--body">
            Document Body
            <span className="grd-band__hint">Read-only · supplied by Complex Phrase</span>
          </div>
          <div className="grd-body">
            <strong>DOCUMENT BODY</strong>
            <p>
              Body content is generated later by the appropriate Complex Phrase and its
              placeholders. It is not designed in this Generic Report Template.
            </p>
          </div>
        </section>

        <section className="grd-band">
          <div className="grd-band__bar">
            Footer — All Pages
            <span className="grd-band__hint">Repeats on every page</span>
          </div>
          <div className="grd-band__editor">
            <ReportSectionEditor
              value={footerHtml}
              onChange={(html) => onChange("footerHtml", html)}
              disabled={disabled}
              surfaceClassName="grd-editor__surface--footer"
              testId={GRD.footer}
              insertPlaceholderTestId={`${GRD.footer}-insert-placeholder`}
              insertLogoTestId={`${GRD.footer}-insert-logo`}
              placeholder="Design the footer…"
            />
          </div>
        </section>
      </div>
    </div>
  );
}
